export const companiesCompanyIdCustomDomainsDomainTypeDomainIdSubscriptionGroups =
  "/companies/:company_id/custom_domains/:domain_type/:domain_id/subscription_groups";
